export default (that) => [
  {
    field: "seq",
    width: 50,
    align: "center",
    fixed: "left",
    type: "seq",
  },
  {
    field: "col-opt",
    title: that.$l("INDEX.table_label_operation") || "操作",
    headerAlign: "center",
    align: "center",
    fixed: "right",
    minWidth: 60,
    slots: {
      default: "opt",
    },
  },
  {
    title: that.$l("table_label_Material_plan_No") || "物料计划编号",
    field: "mrpMaterialPlanNo",
    minWidth: 170,
    headerAlign: "center",
    align: "center",
    showHeaderOverflow: true,
  },
  {
    title: that.$l("INDEX.table_label_order_no") || "订单编号",
    field: "orderNo",
    minWidth: 170,
    headerAlign: "center",
    align: "center",
    showHeaderOverflow: true,
  },
  {
    title: that.$l('form_label_Material_demand_type')||"物料需求种类",
    field: "needKindCount",
    minWidth: 115,
    headerAlign: "center",
    align: "center",
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_Purchased_category')||"已采购种类",
    field: "hasKindCount",
    minWidth: 110,
    headerAlign: "center",
    align: "center",
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_Received_category')||"已入库种类",
    field: "stockKindCount",
    minWidth: 110,
    headerAlign: "center",
    align: "center",
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_Total_demand_quantity')||"总需求数量",
    field: "needTotalQty",
    minWidth: 110,
    headerAlign: "center",
    align: "center",
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_Total_purchased')||"已采购总数",
    field: "hasKTotalQty",
    minWidth: 110,
    headerAlign: "center",
    align: "center",
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_Total_received')|| "已入库总数",
    field: "stockTotalQty",
    minWidth: 120,
    headerAlign: "center",
    align: "center",
    showHeaderOverflow: true,
  },
  {
    title:that.$l('table_label_plan_status')||  "计划状态",
    minWidth: 90,
    headerAlign: "center",
    align: "center",
    showHeaderOverflow: true,
    slots: {
      default: "status",
    },
  },
  {
    title: that.$l('INDEX.creator')||"创建人",
    minWidth: 170,
    headerAlign: "center",
    align: "center",
    showHeaderOverflow: true,
    slots: {
      default: "createInfo",
    },
  },
  {
    title: that.$l('INDEX.table_label_modified_by')||"修改人",
    minWidth: 170,
    headerAlign: "center",
    align: "center",
    showHeaderOverflow: true,
    slots: { default: "modifyInfo" },
  },
  {
    title: that.$l("INDEX.table_label_reviewer_by_name") || "审核人",
    minWidth: 170,
    headerAlign: "center",
    align: "center",
    showHeaderOverflow: true,
    slots: {
       default: "reviewInfo" ,
    },
  },
  {
    title: that.$l("INDEX.order_form_label_custOrderNo") || "客户订单编号",
    field: "custOrderNo",
    minWidth: 105,
    headerAlign: "center",
    align: "center",
    showHeaderOverflow: true,
  },
  {
    title:
      that.$l("INDEX.table_label_business_personnel_name") || "业务人员名字",
    field: "salesPersonName",
    minWidth: 90,
    headerAlign: "center",
    align: "center",
    showHeaderOverflow: true,
  },
  {
    title: that.$l("INDEX.table_hand_nameOfManufacturer") || "厂商名称",
    field: "scmName",
    minWidth: 105,
    headerAlign: "center",
    align: "center",
    showHeaderOverflow: true,
  },
  {
    title: that.$l("INDEX.table_label_order_type") || "订单类型",
    field: "v_orderType",
    minWidth: 105,
    headerAlign: "center",
    align: "center",
    showHeaderOverflow: true,
  },
  {
    title: that.$l("INDEX.table_label_order_source") || "订单来源",
    field: "v_orderSource",
    minWidth: 105,
    headerAlign: "center",
    align: "center",
    showHeaderOverflow: true,
  },
  {
    title: that.$l("INDEX.order_form_label_orderExecuteType") || "执行方式",
    field: "v_orderExecuteType",
    minWidth: 105,
    headerAlign: "center",
    align: "center",
    showHeaderOverflow: true,
  },
]
